const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimezone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-81.857 -184.01 799.395 835.491",
    width: "799.395px",
    height: "835.491px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 686.143 -184.01 L 686.143 354.219 C 705.992 384.446 717.538 420.614 717.538 459.481 C 717.538 565.529 631.586 651.481 525.538 651.481 C 457.01 651.481 396.874 615.59 362.899 561.578 L 174.143 498.659 L -81.857 583.993 L -81.857 -98.674 L 174.143 -184.01 L 430.143 -98.674 Z",
    style: {
      stroke: "#ffffff",
      strokeWidth: 45,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 430.143 -98.674 L 430.143 292.814 C 372.418 325.922 333.538 388.156 333.538 459.481 C 333.538 497.001 344.297 532.006 362.899 561.578 L 174.143 498.659 L 174.143 -184.01 Z",
    style: {
      stroke: "#ffffff",
      strokeWidth: 45,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 518.507 322.797 L 518.173 322.797 L 518.173 472.13 L 518.507 472.13 L 518.507 322.797 Z",
    style: {
      stroke: "#ffffff",
      strokeWidth: 45,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 518.461 476.509 L 518.219 475.752 L 599.264 556.797 L 599.507 557.554 L 518.461 476.509 Z",
    style: {
      stroke: "#ffffff",
      strokeWidth: 45,
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 717.538 459.481 C 717.538 565.529 631.586 651.481 525.538 651.481 C 419.49 651.481 333.538 565.529 333.538 459.481 C 333.538 353.433 419.49 267.481 525.538 267.481 C 631.586 267.481 717.538 353.433 717.538 459.481",
    style: {
      stroke: "#ffffff",
      strokeWidth: 45,
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/timezone.0f48e785c276466f3176d98364b181b7.svg";
export { ForwardRef as ReactComponent };